import { gql } from "types";

export const SIGN_OUT = gql(/* GraphQL */ `
  mutation DeleteCurrentUserSession {
    deleteCurrentUserSession
  }
`);
